/**
 * TEF Designer - Core Widget Registry
 * 
 * Dies ist das Herzstück des Plugin-Systems.
 * Hier melden sich alle Widgets an (z.B. Heading, Image, TarifCard).
 * Der Designer greift *nur* auf diese Registry zu, 
 * um Widgets in der Sidebar anzuzeigen oder im Canvas zu rendern.
 */
class WidgetRegistry {
  constructor() {
    this.widgets = new Map();
    this.categories = {
      layout: 'Layout & Struktur',
      basic: 'Basis Elemente',
      tef: 'TEF Module'
    };
  }

  /**
   * Ein neues Widget im System registrieren.
   * @param {string} type - Der eindeutige Bezeichner (z.B. 'Heading', 'Container')
   * @param {object} config - Die Konfiguration des Widgets
   * @param {string} config.label - Anzeigename (z.B. 'Überschrift')
   * @param {string} config.icon - Icon für die Sidebar (Emoji, SVG oder Icon-String)
   * @param {string} config.category - 'layout', 'basic' oder 'tef'
   * @param {React.Component} config.component - Die React-Render-Komponente
   * @param {Array} config.inspectorControls - Definition der Felder im rechten Inspector
   * @param {object} config.defaultProps - Standardwerte beim Hineinziehen (z.B. color: '#000')
   */
  register(type, config) {
    if (this.widgets.has(type)) {
      console.warn(`[TEF Designer] Widget vom Typ "${type}" ist bereits registriert und wird überschrieben.`);
    }

    this.widgets.set(type, {
      type,
      ...config,
    });

    console.log(`[TEF Designer] Plugin geladen: ${type}`);
  }

  /**
   * Lädt ein einzelnes Widget anhand seines Typs.
   * @param {string} type 
   * @returns {object|null}
   */
  getWidget(type) {
    return this.widgets.get(type) || null;
  }

  /**
   * Liefert alle registrierten Widgets für die Sidebar, gruppiert nach Kategorien.
   */
  getGroupedWidgets() {
    const grouped = {};
    
    // Kategorien initialisieren
    Object.keys(this.categories).forEach(cat => {
      grouped[cat] = {
        id: cat,
        label: this.categories[cat],
        items: []
      };
    });

    // Widgets einsortieren
    this.widgets.forEach(widget => {
      const cat = widget.category || 'basic';
      if (grouped[cat]) {
        grouped[cat].items.push({
          type: widget.type,
          label: widget.label,
          icon: widget.icon,
          defaultProps: widget.defaultProps
        });
      }
    });

    return Object.values(grouped).filter(group => group.items.length > 0);
  }
}

// Singleton Export (Es gibt nur eine globale Registry)
export const registry = new WidgetRegistry();
